import { render } from "./SearchTab.vue?vue&type=template&id=51e0ef27&scoped=true&ts=true"
import script from "./SearchTab.vue?vue&type=script&lang=ts"
export * from "./SearchTab.vue?vue&type=script&lang=ts"

import "./SearchTab.vue?vue&type=style&index=0&id=51e0ef27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e0ef27"]])

export default __exports__